
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 62","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.227 7.36v45.322","fill":"none","stroke":"currentColor","stroke-width":"3.57"}}),_c('path',{attrs:{"d":"M39.069 38.577L23.226 54.278 7.384 38.577","fill":"none","stroke":"currentColor","stroke-width":"3.58"}})])
          )
        }
      }
    